import { cn } from '@shadcn/lib/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-neutral-500/10', className)}
      {...props}
    />
  );
}

export { Skeleton };
